// A note added to a job, or the job reopened, from its sheet (Blueprint moves both there from a
// customer's history rows): the customer's record showing it hears and reads its history again.

const listeners = new Set<() => void>();

/** Hear every one until the returned function is called (a React effect's cleanup). */
export function onJobNoted(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** The job sheet says a note went on a job, or a job was reopened. */
export function jobNoted(): void {
  for (const fn of [...listeners]) fn();
}
